import { useEffect, useRef, useState } from 'react';

const RESIZE_DEBOUNCE_MS = 150;

const useResizeKey = () => {
	const [resizeKey, setResizeKey] = useState(0);
	const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	useEffect(() => {
		const handleResize = () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
			timeoutRef.current = setTimeout(() => {
				setResizeKey((prev) => prev + 1);
			}, RESIZE_DEBOUNCE_MS);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, []);

	return resizeKey;
};

export default useResizeKey;
